var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedFlagratingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flag"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.4375 50.625C7.98995 50.625 7.56073 50.4472 7.24426 50.1307C6.92779 49.8143 6.75 49.3851 6.75 48.9375V7.18559C6.75012 6.74344 6.86605 6.30904 7.08625 5.92564C7.30645 5.54223 7.62324 5.22319 8.00508 5.00027C9.28125 4.25883 11.8526 3.375 16.875 3.375C20.7995 3.375 25.1891 4.92645 29.0619 6.29438C32.1806 7.39652 35.1264 8.4375 37.125 8.4375C39.6978 8.42961 42.2434 7.90974 44.6133 6.9082C44.9019 6.78638 45.2161 6.73787 45.528 6.76699C45.8399 6.7961 46.1398 6.90195 46.4008 7.07508C46.6619 7.24822 46.876 7.48326 47.0242 7.75926C47.1724 8.03525 47.2499 8.34362 47.25 8.65688V31.7925C47.2496 32.2026 47.1296 32.6036 46.9049 32.9466C46.6801 33.2896 46.3602 33.5596 45.9844 33.7236C45.0657 34.1255 41.7118 35.4375 37.125 35.4375C34.579 35.4375 31.3896 34.6845 28.0136 33.8861C24.2188 32.9896 20.2954 32.0625 16.875 32.0625C12.9864 32.0625 10.9962 32.651 10.125 33.0233V48.9375C10.125 49.3851 9.94721 49.8143 9.63074 50.1307C9.31427 50.4472 8.88505 50.625 8.4375 50.625Z",
    fill: "#1B51BB"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedFlagratingIcon);
export default __webpack_public_path__ + "static/media/selected_flagrating_icon.920dfaa77a4e7c015ffb4275ec60a612.svg";
export { ForwardRef as ReactComponent };